const chunk = (array, n) => {
    const result = [];
    for (let i = 0; i < array.length; i += n)
        result.push(array.slice(i, i + n));
    return result;
};

export default chunk;